module.exports = __webpack_public_path__ + "static/media/BUSD_USDT_Mdex.f3beaf6e.png";